import { CSSObject } from "@emotion/react";
import { Border } from "../design-tokens/borders";
import { Colors } from "../design-tokens/colors";
import { Fonts } from "../design-tokens/fonts";
import { grid } from "../design-tokens/grid";
import { Device } from "../design-tokens/media-queries";

const paginationWrapper: CSSObject = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const pageButton: CSSObject = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  backgroundColor: "transparent",
  width: grid(6),
  height: grid(5),
  border: `1px solid ${Colors.BorderGrey}`,
  padding: 0,
  marginRight: "-1px",
  transition: "background-color ease-out 0.3s",
  outline: "0",
  cursor: "pointer",
  WebkitAppearance: "none",

  "&:first-of-type": {
    borderTopLeftRadius: Border.RadiusXs,
    borderBottomLeftRadius: Border.RadiusXs,
  },

  "&:last-of-type": {
    marginRight: "0",
    borderTopRightRadius: Border.RadiusXs,
    borderBottomRightRadius: Border.RadiusXs,
  },

  "&:hover": {
    backgroundColor: Colors.LightestGrey,
    fontWeight: Fonts.Weight.SemiBold,
    transition: "background-color ease-out 0.1s",
  },

  "> *": {
    pointerEvents: "none",
  },

  [Device.MobilePort]: {
    width: grid(5),
    height: grid(4),
  },
};

const active: CSSObject = {
  backgroundColor: Colors.LightGrey,
  fontWeight: Fonts.Weight.SemiBold,
  transition: "background-color ease-out 0.1s",
};

const pageDescription: CSSObject = {
  marginRight: grid(1.5),
  alignSelf: "center",
  textAlign: "right",
  minWidth: grid(8),
};

const styles = {
  paginationWrapper,
  pageButton,
  active,
  pageDescription,
};

export default styles;
